module.exports = __webpack_public_path__ + "img/Drone_vector_Sticker.f07d41e1.png";